import { render, staticRenderFns } from "./FilterOptionGourami.vue?vue&type=template&id=e80a0910&scoped=true&"
import script from "./FilterOptionGourami.vue?vue&type=script&lang=js&"
export * from "./FilterOptionGourami.vue?vue&type=script&lang=js&"
import style0 from "./FilterOptionGourami.vue?vue&type=style&index=0&id=e80a0910&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80a0910",
  null
  
)

export default component.exports